const searchDataActions = {
  SEARCH_DATA_INIT: 'SEARCH_DATA_INIT',
  SEARCH_DATA_SET: 'SEARCH_DATA_SET'
};

export default searchDataActions;